import {SpeakerInvitationDaySlot} from "../../../model/SpeakerInvitationCreateMessage";
import {Checkbox, Stack, Tile} from "@mbank-design/design-system/components";
import React from "react";
import moment from "moment";
import {TileBackgroundColor} from "@mbank-design/design-system/enums";

interface DaySlotsProps {
    slots: SpeakerInvitationDaySlot[],
    onSlotChange: ((slotUIId: number) => void);
}
export default function DaySlots({slots, onSlotChange} : DaySlotsProps) {
    
    return slots && slots.length > 0 ?
        (
            <Stack>
                {slots.map(s => (
                    <Tile key={s.uiId} padding={16} backgroundColor={TileBackgroundColor.MONO_200}>
                        <Checkbox disabled={s.disabled || s.isLunch} checked={s.checked} onChange={(e) => onSlotChange(s.uiId!)}
                                  label={`${moment(s.timeFrom, ["HH:mm:ss"]).format("HH:mm")} - ${moment(s.timeTo, ["HH:mm:ss"]).format("HH:mm")}${s.isLunch ? ' - lunch' : ''}`}
                        />
                    </Tile>
                ))}
            </Stack>
        ) : (<></>);
}